import { toast } from 'sonner';
import { CheckCircle, Info, AlertTriangle, XCircle } from 'lucide-react';

export const getIconByVariant = (variant) => {
  const className = 'w-4 h-4';
  switch (variant) {
    case 'success':     return <CheckCircle className={className} />;
    case 'info':        return <Info className={className} />;
    case 'warning':     return <AlertTriangle className={className} />;
    case 'destructive': return <XCircle className={className} />;
    default:            return <Info className={className} />;
  }
};

const toastStyles = {
  success: {
    style: {
      background: '#2d6a4f',
      color: 'white',
      borderColor: '#1b4332',
    },
  },
  info: {
    style: {
      background: '#6b4b3e',
      color: 'white',
      borderColor: '#4a332b',
    },
  },
  warning: {
    style: {
      background: '#ae7857',
      color: 'white',
      borderColor: '#8a5e42',
    },
  },
  destructive: {
    style: {
      background: '#b91c1c',
      color: 'white',
      borderColor: '#991b1b',
    },
  },
};

export const showToast = ({
  variant = 'info',
  title,
  description,
  duration = 4000,
  icon,
  onClose,
}) => {
  const iconElement = icon || getIconByVariant(variant);

  return toast[variant === 'destructive' ? 'error' : variant](title, {
    duration,
    description,
    icon: iconElement,
    onDismiss: onClose,
    ...toastStyles[variant],
  });
};

export const toastSuccess = (title, description, duration, icon) =>
  showToast({ variant: 'success', title, description, duration, icon });

export const toastInfo = (title, description, duration, icon) =>
  showToast({ variant: 'info', title, description, duration, icon });

export const toastWarning = (title, description, duration, icon) =>
  showToast({ variant: 'warning', title, description, duration, icon });

export const toastError = (title, description, duration, icon) =>
  showToast({ variant: 'destructive', title, description, duration, icon });